import api from 'networkapp-api-connector';
import * as Sentry from '@sentry/react';

export default {
    ping: function () {
        return api.misc
            .ping()
            .then(() => {
                app.store.dispatch(app.actions.session.setConnectionStatus(true));
            })
            .catch(err => {
                app.store.dispatch(app.actions.session.setConnectionStatus(false));
                Sentry.addBreadcrumb({
                    category: 'connection',
                    message: 'Unable to reach api server',
                });
                throw err;
            });
    },
    verifyCode: function (code) {
        return api.misc.verifyCode(code).then(data => {
            return data;
        });
    },
    connections: function () {
        return api.misc.connections().then(data => {
            app.store.dispatch(app.actions.connections.updateUserConnections(data.result));
            return data.result;
        });
    },
    sendEmail: function (receiverId, subject, message) {
        let state = app.store.getState(),
            senderId = state.session.user.id;
        return api.misc.sendEmail(senderId, receiverId, subject, message).then(response => {
            if (!response.sent == 'yes') {
                console.warn(response);
                throw new Error('Failed to send email');
            }
            return response;
        });
    },
};
